import { useCallback, useState } from 'react';

export const useConfirmationDialog = () => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const handleDialogClose = useCallback(() => {
    setIsDialogOpen(false);
  }, []);

  const handleDialogOpen = useCallback(() => {
    setIsDialogOpen(true);
  }, []);

  return {
    isDialogOpen,
    handleDialogClose,
    handleDialogOpen,
  };
};
